import $ from "jquery";

$(document).ready(function () {
  // Add some invisible elements with Bootstrap CSS visibile utility classes
  $("body").append(
    "<div style='display:none;' class='viewport-check'><span class='d-block'></span><span class='d-sm-block'></span><span class='d-md-block'></span><span class='d-lg-block'></span><span class='d-xl-block'></span></div>"
  );

  function isBlock(target: string): boolean {
    return $(target).css("display") == "block";
  }

  function isBelowLarge(): boolean {
    return !isBlock(".viewport-check .d-lg-block");
  }

  function isLargeOrUp(): boolean {
    return isBlock(".viewport-check .d-lg-block");
  }
  const header = $("#header");
  const navbar = $("#navbar");
  const navbarContent = $("#navbarContent");

  function onShow(): void {
    header.removeClass("bg-white");
    header.addClass("bg-black");
    navbar.removeClass("navbar-light");
    navbar.addClass("navbar-dark");
  }

  function onHide(): void {
    header.addClass("bg-white");
    header.removeClass("bg-black");
    navbar.addClass("navbar-light");
    navbar.removeClass("navbar-dark");
  }

  navbarContent.on("show.bs.collapse", onShow);
  navbarContent.on("hide.bs.collapse", onHide);

  let resizeTimer: number | undefined;
  $(window).resize(function () {
    window.clearTimeout(resizeTimer);
    // Using a timeout of 16ms which is equivalent to 1 frame on a 60fps monitor
    resizeTimer = window.setTimeout(function () {
      // Resizing has stopped long enough to run the code.
      if (isLargeOrUp() && navbarContent.hasClass("show")) {
        onHide();
      }
      if (isBelowLarge() && navbarContent.hasClass("show")) {
        onShow();
      }
    }, 16);
  });
});

// animated header
$(document).ready(function () {
  const header = $("#header")[0];
  $(window).scroll(function () {
    if ($(window).scrollTop() == 0) {
      header.classList.remove("header--small");
      header.classList.add("header--big");
    } else {
      header.classList.add("header--small");
      header.classList.remove("header--big");
    }
  });
});
